import React from 'react'
import { Button } from '@mui/material'
import { bool, func, any } from 'prop-types'
export default function ButtonVideoNotIOS({ resumo, hasFile, onClick, isIOS }) {
  return (
    <>
      {!isIOS && (
        <Button
          disabled={!!resumo}
          onClick={onClick}
          sx={{
            display: hasFile ? 'none' : 'block',
            padding: '0.5rem 3rem',
            color: 'white',
            height: 'max-content'
          }}
          variant="contained"
          color="warning"
        >
          Gravar
        </Button>
      )}
    </>
  )
}
ButtonVideoNotIOS.propTypes = {
  resumo: any,
  hasFile: bool,
  onClick: func,
  isIOS: bool
}
